import format from "date-fns/format";
import React, { useState } from "react";
import { Exercise } from "../../../models/Exercise";
import useMethodAccount from "../hooks/useMethodAccount";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { HiOutlineClock } from "react-icons/hi";
import HtmlTooltip from "@mui/material/Tooltip";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  exercise: Exercise;
  getSelect: () => void;
}

const SingleExercise: React.FC<IProps> = ({ exercise, getSelect }: IProps) => {
  const [open, setOpen] = useState(true);
  const { t } = useTranslation();
  const { resignExercise, alert } = useMethodAccount();
  const currentTime = new Date();
  const currentTimev2 = currentTime.getTime();
  const locale = useLocaleByLanguage();

  return (
    <>
      {open ? (
        <>
          {exercise.startTime > currentTimev2 && (
            <>
              <div className="single-reservation-desktop">
                <div className="single-reservation flex-between-center">
                  <div className="hours flex-column">
                    <b className="startTime">{format(exercise.startTime, "HH:mm")}</b>
                    <b className="closeTime">{format(exercise.closeTime, "HH:mm")}</b>
                  </div>
                  <div className="details flex-column">
                    <b>{exercise.name}</b>
                    <span>
                      {" "}
                      {format(exercise.startTime, "cccc", { locale: locale })},{" "}
                      {format(exercise.startTime, "d", {
                        locale: locale,
                      })}{" "}
                      {format(exercise.startTime, "MMM", {
                        locale: locale,
                      })}{" "}
                      | {format(exercise.startTime, "HH:mm")} - {format(exercise.closeTime, "HH:mm")}
                    </span>
                  </div>
                  <div className="status">
                    <HtmlTooltip
                      placement="top"
                      title={
                        <>
                          <article
                            className="tooltip-description"
                            dangerouslySetInnerHTML={{ __html: "Jesteś na liście rezerwowej" }}
                          ></article>
                        </>
                      }
                    >
                      <>
                        {" "}
                        {exercise.status === "R" && (
                          <div className="alert alert-yellow">
                            <HiOutlineClock className="alert-icon-background" /> Jesteś {exercise.waitListPosition} w
                            kolejce
                          </div>
                        )}
                      </>
                    </HtmlTooltip>
                  </div>
                  <div className="action">
                    <EAButton title="Anuluj rezerwacje" onClick={() => setOpen(!open)} variant="outlined" />
                  </div>
                </div>
                {alert !== "" && (
                  <div className="flex-between-center alert alert-red ">
                    <b>{alert}</b>
                  </div>
                )}
              </div>

              <div className="single-reservation-mobile">
                <div className="single-reservation flex-between-center">
                  <div className="hours flex-column">
                    <b className="startTime">{format(exercise.startTime, "HH:mm")}</b>
                    <b className="closeTime">{format(exercise.closeTime, "HH:mm")}</b>
                  </div>

                  <div className="details flex-column">
                    <b>{exercise.name}</b>
                    <span>
                      {" "}
                      {format(exercise.startTime, "cccc", { locale: locale })},{" "}
                      {format(exercise.startTime, "d", {
                        locale: locale,
                      })}{" "}
                      {format(exercise.startTime, "MMM", {
                        locale: locale,
                      })}{" "}
                      | {format(exercise.startTime, "HH:mm")} - {format(exercise.closeTime, "HH:mm")}
                    </span>

                    <HtmlTooltip
                      placement="top"
                      title={
                        <>
                          <article
                            className="tooltip-description"
                            dangerouslySetInnerHTML={{ __html: "Jesteś na liście rezerwowej" }}
                          ></article>
                        </>
                      }
                    >
                      <>
                        {" "}
                        {exercise.status === "R" && (
                          <div className="alert alert-yellow">
                            <HiOutlineClock className="alert-icon-background" /> Jesteś {exercise.waitListPosition} w
                            kolejce
                          </div>
                        )}
                      </>
                    </HtmlTooltip>
                    {alert !== "" && (
                      <div className="flex-between-center alert alert-red ">
                        <b>{alert}</b>
                      </div>
                    )}
                    <EAButton title="Anuluj rezerwacje" onClick={() => setOpen(!open)} variant="outlined" />
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <div className="select-pass-resign-alert">
          <h4>{t("czy_na_pewno_chcesz_zrezygnowac_z_tego_terminu")}</h4>
          <div className="flex-center-center">
            <EAButton
              title={t("tak_rezygnuje")}
              onClick={() => {
                resignExercise(exercise.objectId);
                getSelect();
                setOpen(!open);
              }}
              variant="text"
            />
            <EAButton title={t("nie")} onClick={() => setOpen(!open)} />
          </div>
        </div>
      )}
    </>
  );
};

export default SingleExercise;
